export default {
  title: 'Service Charter',
  content: `
    <p>
      Polaris Pension Insurance Agency (2018) Ltd. (hereinafter: "the Agency") undertakes to operate in accordance with a customer-centric approach. This commitment is for the benefit of all our customers, in accordance with the Customer Service Charter and with the vision and core values of the Agency.
    </p>

    <p>
      <h3>Fairness and Respect for Privacy</h3>
      The customer is entitled to privacy, and we therefore undertake to maintain the confidentiality of our conversations with the customer and of the customer's records, in accordance with the provisions of law.
      Our activities on behalf of our customers are conducted fairly and respectfully, with due regard for the customer's time.
    </p>

    <p>
      <h3>Availability and Efficiency in Providing a Personal Response to Every Customer</h3>
      We make available to the customer a variety of means
      of contacting us: email, website, fax, mail, and personal telephone service handled by a live representative.
    </p>

    <p>
      <h3>The Agency's reception hours and customer service hours are:</h3>
      3 Shenkar St., Herzliya Pituach
      <br/>
      Reception by prior appointment: Sun–Thu
      <br/>
      Hours:  09:00-17:00
      <br/>
      Friday closed
    </p>

    <p>
      <h3>Contact Us:</h3>
      Phone: 050-7683557
      <br/>
      Email: service@polaris-fin.co.il
      <br/>
      Website: www.polaris-fin.co.il
    </p>

    <p>
      <strong>We are here for the customer.</strong>
    </p>

    <p>
      The Agency shall provide a response appropriate to the customer's needs,
      within seven business days of a customer's request to schedule a meeting or to receive documents.
      <br/>
      The Agency shall maintain efficient and accessible communication with its customers, shall provide an initial response to every inquiry,
      and shall provide answers that are as clear and well-reasoned as possible, within two business days of receipt of the customer's inquiry.
      <br/>
      The Agency shall provide a substantive response within a reasonable time to a customer's inquiry concerning a claim, without
      derogating from the provisions of any law in this regard. Furthermore, the Agency shall provide a customer who has contacted it regarding
      a claim with information about the customer's rights and the courses of action available to the customer in the claim settlement process.
    </p>

    <p>
      <h3>Transparency and Simplicity</h3>
      We strive to create an easy and pleasant experience for the customer: to speak with the customer in clear and comprehensible language, to explain and simplify
      the steps required to carry out the customer's requests, and to accompany the customer through the necessary bureaucracy vis-à-vis the insurance companies.
    </p>

    <p>
      <h3>Professionalism</h3>
      Insurance is one of the most important and significant means available to the customer for reducing risk and securing the future.
      We undertake to place at the customer's disposal the finest, most expert and most experienced staff in the field,
      who undergo professional training as required. Whenever a customer contacts us,
      we undertake to provide a response suited to the customer's needs and in accordance with the personal preferences of each customer.
    </p>
  `,
};
